import { Box, type BoxProps } from '@mui/material';
import { styled } from '@mui/material/styles';

import { containerHeight } from '../data';

export type ContentContainerProps = Omit<BoxProps, 'children'>;
export const ContentContainer = styled(Box)({
  padding: '20px 30px',
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  flexBasis: `
  calc(100vh - ${containerHeight.title}px - ${containerHeight.action}px)`,
  font: 'inherit',
  fontSize: 14,
});
